module.exports = __webpack_public_path__ + "static/media/preview_chart_2_Leads.4ef9f045.PNG";